//get role of user
export const Roles = () => {
    let roles = localStorage.getItem('roles')
    return roles ? JSON.parse(roles) : null
};

export const IsAdmin = () => {
    let userData = localStorage.getItem('userData')
    return userData ? JSON.parse(userData).is_admin : null;
}